/**
 * Retorna estilos para MenuItem baseado no buttonClass
 */
export const getActionButtonStyles = (buttonClass, theme) => {
  // Mapeamento de classes predefinidas
  const PREDEFINED_CLASSES = {
    "btn-primary": { color: theme.palette.primary.main },
    "btn-secondary": { color: theme.palette.secondary.main },
    "btn-success": { color: theme.palette.success.main },
    "btn-info": { color: theme.palette.info.main },
    "btn-warning": { color: theme.palette.warning.main },
    "btn-danger": { color: theme.palette.error.main },
    "btn-default": { color: theme.palette.text.secondary },
  };

  // Caso 1: String predefinida
  if (typeof buttonClass === "string" && PREDEFINED_CLASSES[buttonClass]) {
    return PREDEFINED_CLASSES[buttonClass];
  }

  // Caso 2: Hexadecimal (tolerante a erros comuns)
  if (typeof buttonClass === "string") {
    // Remove espaços e # extras no início
    const cleanedColor = buttonClass.trim().replace(/^#+/, "#");

    // Valida hexadecimal (#RGB ou #RRGGBB)
    if (/^#([0-9A-F]{3}){1,2}$/i.test(cleanedColor)) {
      return { color: cleanedColor };
    }
  }

  // Caso 3: Objeto customizado
  if (typeof buttonClass === "object" && buttonClass !== null) {
    // Limpa possíveis ## nos valores
    const cleanHex = (value) => {
      if (typeof value === "string") {
        return value.replace(/^#+/, "#");
      }
      return value;
    };

    const bgColor = cleanHex(buttonClass.bgColor);
    const color = cleanHex(buttonClass.color || buttonClass.textColor);
    const iconColor = cleanHex(buttonClass.iconColor);

    return {
      backgroundColor: bgColor,
      color: color || theme.palette.text.primary,
      iconColor: iconColor || color || theme.palette.text.primary,
      "&:hover": {
        backgroundColor: cleanHex(buttonClass.bgColorHover) || bgColor,
      },
    };
  }

  // Fallback
  return { color: theme.palette.text.secondary };
};

/**
 * Extrai a cor do ícone
 */
export const getActionIconColor = (buttonClass, theme) => {
  const styles = getActionButtonStyles(buttonClass, theme);
  return styles.iconColor || styles.color;
};
